import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ConfigService } from '@app/@core/@config/config.service';

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {
  private renderer: Renderer2;
  private added = false;

  constructor(private rendererFactory: RendererFactory2, private configService: ConfigService) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init() {
    const googleTagManagerId = this.configService.getNetworkData()?.googleTagManagerId;
    if (this.added || !googleTagManagerId || this.configService.isLocalhost()) {
      return;
    }

    // Insert <script> into <head>
    const script = this.renderer.createElement('script');
    script.text = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${googleTagManagerId}');
    `;
    this.renderer.appendChild(document.head, script);

    // Insert <noscript> iframe into <body>
    const noscript = this.renderer.createElement('noscript');
    const iframe = this.renderer.createElement('iframe');
    this.renderer.setAttribute(iframe, 'src', `https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}`);
    this.renderer.setAttribute(iframe, 'height', '0');
    this.renderer.setAttribute(iframe, 'width', '0');
    this.renderer.setStyle(iframe, 'display', 'none');
    this.renderer.setStyle(iframe, 'visibility', 'hidden');
    this.renderer.appendChild(noscript, iframe);
    this.renderer.appendChild(document.body, noscript);

    this.added = true;
  }
}
